export default __webpack_public_path__ + "static/media/ac8f0bc9c93df4aa.5efb1a838ebd92ac89afe3fa7ecb4b93.svg";